<style lang="less" scoped>
  .header {
    display: flex;
    padding-bottom: 24px;
  }
  .stop {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
</style>

<template lang="pug">
  .header
    .stop(@click='handleStop') 그만하기
</template>

<script>
export default {
  methods: {
    handleStop() {
      this.$emit('click-stop');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/stop.vue